import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { LandingNavbar } from '../components/public/landing/LandingNavbar';
import { LandingFooter } from '../components/public/landing/LandingFooter';

export const PublicLayout = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <div className="min-h-screen bg-meetoi-offwhite flex flex-col font-manrope text-meetoi-text selection:bg-meetoi-navy selection:text-white">
      <LandingNavbar />
      <main className={`flex-grow ${!isHomePage ? 'pt-20' : ''}`}>
        <Outlet />
      </main>
      <LandingFooter />
    </div>
  );
};